import React from "react";
import EmployeeSheetTable from "../../components/ui-custom/EmployeeSheetTable";

const Deliverables = () => (
  <div>
    <h2 className="font-display font-semibold text-2xl text-foreground mb-6">Deliverables Dashboard</h2>
    <EmployeeSheetTable
      endpoint="/employees/deliverables"
      emptyLabel="No deliverables have been added to the tracking sheet yet."
    />
  </div>
);

export default Deliverables;
